import Phaser from 'phaser';
import { CONFIG } from '../config.js';

const C = CONFIG.COLORS;

export class AnswerButtons {
  constructor(scene) {
    this.scene = scene;
    this.buttons = [];
    this.currentQuestion = null;
    this.locked = false;
    this.create();
  }

  create() {
    const W = CONFIG.GAME_WIDTH;
    const H = CONFIG.GAME_HEIGHT;
    const panelTop = H - 168;
    const panelHeight = 160;

    this.panel = this.scene.add
      .rectangle(W / 2, panelTop + panelHeight / 2, W - 8, panelHeight, C.UI_PANEL, 0.94)
      .setStrokeStyle(2, C.UI_PANEL_BORDER, 1)
      .setDepth(40);

    this.label = this.scene.add
      .text(W / 2, panelTop + 12, 'PAST SIMPLE', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '10px',
        color: '#fbbf24',
      })
      .setOrigin(0.5)
      .setDepth(41);

    this.helpText = this.scene.add
      .text(W / 2, panelTop + 30, '', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '12px',
        color: '#ffffff',
      })
      .setOrigin(0.5)
      .setDepth(41);

    const btnW = 145;
    const btnH = 60;
    const gap = 8;
    const totalW = btnW * 3 + gap * 2;
    const startX = (W - totalW) / 2 + btnW / 2;
    const btnY = panelTop + 95;

    for (let i = 0; i < 3; i++) {
      const x = startX + i * (btnW + gap);
      const bg = this.scene.add
        .rectangle(x, btnY, btnW, btnH, 0x312e81, 1)
        .setStrokeStyle(2, C.UI_PRIMARY, 0.95)
        .setDepth(41);
      const text = this.scene.add
        .text(x, btnY, '', {
          fontFamily: '"Press Start 2P", monospace',
          fontSize: '14px',
          color: '#ffffff',
          align: 'center',
        })
        .setOrigin(0.5)
        .setDepth(42);
      const numLabel = this.scene.add
        .text(x - btnW / 2 + 6, btnY - btnH / 2 + 5, String(i + 1), {
          fontFamily: '"Press Start 2P", monospace',
          fontSize: '8px',
          color: '#fbbf24',
        })
        .setDepth(42);

      bg.setInteractive({ useHandCursor: true });
      bg.on('pointerdown', () => bg.setScale(0.96));
      bg.on('pointerout', () => bg.setScale(1));
      bg.on('pointerup', (pointer, localX, localY, event) => {
        bg.setScale(1);
        if (event && event.stopPropagation) event.stopPropagation();
        this.handleAnswer(i);
      });
      this.buttons.push({ bg, text, numLabel, idx: i });
    }

    this.scene.input.keyboard.on('keydown-ONE', () => this.handleAnswer(0));
    this.scene.input.keyboard.on('keydown-TWO', () => this.handleAnswer(1));
    this.scene.input.keyboard.on('keydown-THREE', () => this.handleAnswer(2));

    this.setQuestion(null);
  }

  setQuestion(q) {
    this.currentQuestion = q;
    if (!q) {
      this.label.setText('NO TARGETS');
      this.helpText.setText('mantente vivo!');
      for (let i = 0; i < 3; i++) {
        this.buttons[i].text.setText('—');
        this.buttons[i].bg.setFillStyle(0x1f1d4d, 1);
        this.buttons[i].bg.setStrokeStyle(2, 0x4338ca, 0.8);
      }
      this.locked = true;
      return;
    }
    this.label.setText(q.label);
    this.helpText.setText(`${q.verbBase}  (${q.es})`);
    for (let i = 0; i < 3; i++) {
      this.buttons[i].text.setText(q.options[i] || '');
      this.buttons[i].bg.setFillStyle(0x312e81, 1);
      this.buttons[i].bg.setStrokeStyle(2, C.UI_PRIMARY, 0.95);
    }
    this.locked = false;
  }

  flashCorrect(idx) {
    const btn = this.buttons[idx];
    if (!btn) return;
    btn.bg.setFillStyle(0x22c55e, 1);
    btn.bg.setStrokeStyle(2, 0xffffff, 1);
  }

  flashWrong(idx) {
    const btn = this.buttons[idx];
    if (!btn) return;
    btn.bg.setFillStyle(0xef4444, 1);
    btn.bg.setStrokeStyle(2, 0xffffff, 1);
    this.scene.tweens.add({
      targets: btn.bg,
      x: btn.bg.x + 4,
      yoyo: true,
      repeat: 3,
      duration: 40,
      onComplete: () => btn.bg.setX(btn.bg.x), // already at x; fine
    });
  }

  handleAnswer(idx) {
    if (this.locked || !this.currentQuestion) return;
    const option = this.currentQuestion.options[idx];
    if (option === undefined) return;
    const isCorrect = option === this.currentQuestion.correct;
    this.locked = true;
    if (isCorrect) this.flashCorrect(idx);
    else this.flashWrong(idx);
    this.scene.time.delayedCall(140, () => {
      this.locked = false;
    });
    this.scene.events.emit('answer', { idx, option, isCorrect });
  }
}
